<script lang="ts">
  import { page } from '$app/state';
  import { onNavigate } from '$app/navigation';
  import SiteMotion from '$lib/components/landing/site-motion.svelte';
  import Navigation from '$lib/components/navigation.svelte';
  import Footer from '$lib/components/footer.svelte';
  import NotFound from '$lib/components/site/not-found-page.svelte';
  import { ScrollToTop } from '@cio/ui/custom/scroll-to-top';
  import extend from 'just-extend';
  import { JsonLd, MetaTags } from 'svelte-meta-tags';
  import { isMotionAllowed } from '$lib/utils/motion-state.svelte';
  import { organizationSchema, websiteSchema } from '$lib/utils/structured-data';
  import '../app.css';

  let { children, data } = $props();
  let metaTags = $derived(
    extend(
      true,
      {},
      data.baseMetaTags,
      page.status === 404 ? { title: 'Page not found | Edvello', robots: 'noindex,follow' } : page.data.pageMetaTags
    )
  );
  const siteSchema = [organizationSchema(), websiteSchema()];

  onNavigate((navigation) => {
    if (navigation.from?.url.pathname === navigation.to?.url.pathname) return;
    if (!isMotionAllowed()) return;

    document.documentElement.dataset.motionBoot = 'pending';
    if (!document.startViewTransition) return;

    return new Promise((resolve) => {
      document.startViewTransition(async () => {
        resolve();
        await navigation.complete;
      });
    });
  });
</script>

<MetaTags {...metaTags} />
<JsonLd schema={siteSchema} />
<Navigation />
<SiteMotion />
<main id="main-content" tabindex="-1">
  {#if page.status === 404}
    <NotFound />
  {:else}
    {@render children?.()}
  {/if}
</main>
<Footer />
<ScrollToTop label="Scroll to top" />
